// import React from 'react';
import ThreeTop from './Topbar';
import React,{ useState} from 'react';

import FilterSidebar from './Filtersidebar';
// import BlogCard from './Blogcard';
import BlogGrid from './Bloggrid';
import './One.css';

function Combainblog() {
    const [showFilter, setShowFilter] = useState(true);

    const toggleFilter = () => {
        setShowFilter(prev => !prev);
    };
    return (
        <>

            <div className='well-top'>               
                 <ThreeTop />
                <div className='well-align'>
                {showFilter && <FilterSidebar />}
                    {/* <FilterSidebar /> */}
                    <FilterSidebar isVisible={showFilter} />

                    <BlogGrid />
                </div>
            </div>
        </>
    );
}
export default Combainblog;
